import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import GridLayout from '../../../../components/common/GridLayout';
import { IS_TAB } from '../../../../utils/common';
import Carousel from '../../../../components/common/Carousel';
import useCarouselItemConfig from '../../../../hooks/useCarouselItemConfig';
import Tabs from '../../../../components/common/Tabs';

const FrontPrint = ({
  options,
  initialSelectedCustomizationIndex,
  updatePartsConfig,
  partsConfig,
  selectedPart
}) => {
  const [data, setData] = useState(options);
  const [tabs, setTabs] = useState(['Prints', 'AOM']);
  const [activeTab, setActiveTab] = useState('Prints');

  useEffect(() => {
    setData(
      options.filter(
        opt =>
          (activeTab === 'Prints' && !opt.configData.groupCategory) ||
          opt.configData.groupCategory === activeTab
      )
    );
  }, [options, activeTab]);

  const { ref: cardRef, width: cardWidth } = useCarouselItemConfig();

  return (
    <div className="front-print">
      <Tabs
        columns={tabs.length}
        selectedTab={activeTab}
        setSelectedTab={tab => {
          setActiveTab(tab);
        }}
        className="front-badge-sticky"
        options={tabs}
      />
      {IS_TAB ? (
        <Carousel noOfItems={options && options.length} itemWidth={cardWidth}>
          {data.map((option, i) => (
            <div
              ref={cardRef}
              role="presentation"
              onKeyDown={() => {}}
              key={option.id}
              className={`front-print-image  ${selectedPart === option.partId &&
                'front-print-image-selected'}`}
              style={{ backgroundImage: `url(${option.configData.thumbnail})` }}
              onClick={() => {
                updatePartsConfig(option);
              }}
            />
          ))}
        </Carousel>
      ) : (
        <GridLayout columns={4}>
          {data.map((option, i) => (
            <div
              role="presentation"
              onKeyDown={() => {}}
              key={option.id}
              className={`front-print-image  ${selectedPart === option.partId &&
                'front-print-image-selected'}`}
              style={{ backgroundImage: `url(${option.configData.thumbnail})` }}
              onClick={() => {
                updatePartsConfig(option);
              }}
            />
          ))}
        </GridLayout>
      )}
    </div>
  );
};

FrontPrint.propTypes = {
  options: PropTypes.array,
  initialSelectedCustomizationIndex: PropTypes.number,
  updatePartsConfig: PropTypes.func,
  partsConfig: PropTypes.object
};

export default FrontPrint;
